module.exports = __webpack_public_path__ + "57fdbd5f268abec7b3db7c301f53c6e3.png";